var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand"},[_c('router-link',{staticClass:"router-link",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/images/logo.svg"),"alt":"Logo Asuaire"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }